export interface BenefitsSectionConfig {
  etiqueta: string;
  titulo: string;
  descripcion: string;
  imagen_url: string;
  imagen_alt: string;
  // "" = automatico: la foto original se ve como franja recortada y las fotos propias completas.
  imagen_ajuste: string;
}

export type ImageFit = "completa" | "recortar";

// Textos y foto originales de la seccion "El recinto": se usan mientras no se guarde nada desde el admin.
export const DEFAULT_BENEFITS_SECTION: BenefitsSectionConfig = {
  etiqueta: "El recinto",
  titulo: "Un recinto pensado para operar en serio",
  descripcion:
    "No somos un estacionamiento con puertas. Cada detalle está pensado para que muevas tu carga con tranquilidad y controles tus costos al peso.",
  imagen_url:
    "https://readdy.ai/api/search-image?query=Wide%20clean%20paved%20industrial%20yard%20with%20a%20large%20truck%20maneuvering%20in%20front%20of%20warehouse%20loading%20docks%2C%20grey%20concrete%20building%2C%20overcast%20soft%20daylight%2C%20southern%20Chile%20forest%20and%20lake%20in%20background%2C%20premium%20industrial%20photography%2C%20muted%20earthy%20tones%2C%20no%20people%2C%20high%20detail&width=1200&height=600&seq=beneficio-patio&orientation=landscape",
  imagen_alt: "Patio de maniobras para camiones en el recinto",
  imagen_ajuste: "",
};

export function effectiveImageFit(cfg: BenefitsSectionConfig): ImageFit {
  if (cfg.imagen_ajuste === "completa" || cfg.imagen_ajuste === "recortar") return cfg.imagen_ajuste;
  return cfg.imagen_url === DEFAULT_BENEFITS_SECTION.imagen_url ? "recortar" : "completa";
}

export function mergeBenefitsSection(saved?: Partial<BenefitsSectionConfig> | null): BenefitsSectionConfig {
  const merged = { ...DEFAULT_BENEFITS_SECTION };
  for (const key of Object.keys(merged) as (keyof BenefitsSectionConfig)[]) {
    const value = saved?.[key];
    if (typeof value === "string") merged[key] = value;
  }
  return merged;
}
